import gql from "graphql-tag";

export default gql`
  query getCreditHealthRating($query: QueryInput, $offset: OffsetInput) {
    getCreditHealthRating(query: $query, offset: $offset) {
      __typename
      id
      friendly_entity_id
      health_rating
      current
      user
      created_time
      modified_time
    }
  }
`;
